import styled from 'styled-components';

export default styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${({ light, theme }) =>
    light ? theme.colors.primary.light : theme.colors.black};
`;
